import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'digitFormat' 
})

export class DigitFormatPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num =
      typeof value === 'string'
        ? Number(value)
        : value;

    if (isNaN(num)) return '';

    return new Intl.NumberFormat('sr-RS', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(num);
  }
}